import { render, staticRenderFns } from "./DocumentTile.vue?vue&type=template&id=0063a860&scoped=true"
import script from "./DocumentTile.vue?vue&type=script&lang=ts"
export * from "./DocumentTile.vue?vue&type=script&lang=ts"
import style0 from "./DocumentTile.vue?vue&type=style&index=0&id=0063a860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0063a860",
  null
  
)

export default component.exports